<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="库区名称">
        <el-select placeholder="全部" v-model="formInline.regionCode">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option :label="item.regionName" :value="item.regionCode" v-for="item in regionList" :key="item.regionCode"> </el-option>
        </el-select>
        <!-- <el-input maxlength='450' v-model="formInline.regionCode" placeholder="库区名称" @change="$emit('search', formInline)"></el-input> -->
      </el-form-item>
      <el-form-item label="库位编码">
        <el-input
          maxlength="450"
          v-model.trim="formInline.gridCode"
          clearable
          placeholder="请输入库位编码"
          @keyup.enter.native="$emit('search', formInline)"
        />
      </el-form-item>
      <!-- <el-form-item label="通道名称">
        <el-input maxlength='450' v-model="formInline.aisleName" placeholder="负责人" @change="$emit('search', formInline)"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <!-- <el-button style="margin-left: 10px" @click="rest">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "Form",
  data() {
    return {
      formInline: {
        regionCode: undefined,
        gridCode: "",
      }
    }
  },
  props:{
    regionList:{
      type: Array
    }
  },
  mounted() {
    this.$emit('search', this.formInline)
  },
  methods: {
    rest: function () {
      this.formInline = {}
      this.$emit('search', this.formInline)
    }
  }
}
</script>

<style scoped>

</style>